import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Unauthorized from "./components/Unauthorized";
import LoginPage from "./pages/LoginPage";
import ProgressStatus from "./pages/ProgressStatus";
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';
import Dashboard from "./pages/Dashboard";
import Layout from "./pages/layout/Layout";
import Settings from "./pages/settings/Settings";
import ChangePassword from "./pages/settings/ChangePassword";
import NotificationProviderSettings from "./pages/admin/NotificationProviderSettings";
import NewOrg from "./pages/settings/NewOrg";
import NewDept from "./pages/settings/NewDept";
import NewTeam from "./pages/NewTeam";

import TicketHeads from "./pages/settings/TicketHeads";
import NewPhead from "./pages/settings/NewPhead";
import ModifyHead from "./pages/settings/ModifyHead";
import HeadCheckList from "./pages/settings/HeadCheckList";

import NewCategory from "./pages/settings/NewCategory";
import NewPriority from "./pages/settings/NewPriority";
import NewProgressStatus from "./pages/settings/NewProgressStatus";
import ModifyCategory from "./pages/settings/ModifyCategory";

import Cliente from "./pages/cliente/Cliente";
import ClientDashboard from "./pages/cliente/ClientDashboard";

import Ajustes from "./pages/ajustes/ajustes";
import DynamicFormBuilder from "./pages/ajustes/dfBuilder";

import { AppProvider } from "./context/AppContext";
import AddTicket from "./pages/tickets/AddTicket";
import NewTickets from "./pages/tickets/NewTickets";
import UpdateTicket from "./pages/tickets/UpdateTicket";
import TicketSummary from './pages/tickets/TicketSummary';
import TicketSearch from './pages/tickets/TicketSearch';
import MyTickets from "./pages/tickets/MyTickets";
import AssignedTickets from "./pages/tickets/AssignedTickets";

import AdminUsers from "./pages/admin/AdminUsers";
import AdminUser from "./pages/admin/AdminUser";
import ManageUser from "./pages/admin/ManageUser";
import NewUser from "./pages/admin/NewUser";
import SmsEventSettings from "./pages/admin/SmsEventSettings";
import AddSmsEvent from "./pages/admin/AddSmsEvent";
import RunQuery from "./pages/admin/RunQuery";
import ApiEndPoint from "./pages/admin/ApiEndPoint";
import CustomerEndPoint from "./pages/admin/CustomerApiEndPoint";
import CustomerForm from "./pages/ajustes/customerForm";
import ReportSettings from "./pages/admin/ReportSettings";
import Entries from "./pages/report/entries";
import TicketSummaryReport from "./pages/report/ticketSummaryReport";


import RoleBasedRoute from "./routes/RoleBasedRoute";
import OrganizationSettings from "./pages/admin/OrganizationSettings";

// const user = JSON.parse(sessionStorage.getItem('lgusr'));
// const role = user?.role;

function App() {
  const user = JSON.parse(sessionStorage.getItem('lgusr'));
  document.title = "Ticketing";

  return (
    <DndProvider backend={HTML5Backend}>
      <AppProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={!user ? <LoginPage /> : <Navigate to="/" />} />
            <Route path="/progress-status/:id" element={<ProgressStatus />} />
            {/* Authenticated Routes */}
            <Route path="/" element={user ? (<Layout><Dashboard /></Layout>) : (<Navigate to="/login" />)} />
            <Route path="/dashboard" element={user ? (<Layout><Dashboard /></Layout>) : (<Navigate to="/login" />)} />
            <Route path="/change-password" element={user ? (<Layout><ChangePassword /></Layout>) : (<Navigate to="/login" />)} />

            {/* Tickets Routes */}
            <Route path="/tickets/add-ticket" element={user ? (<Layout><AddTicket /></Layout>) : (<Navigate to="/login" />)} />
            <Route path="/tickets/new-ticket" element={user ? (<Layout><NewTickets /></Layout>) : (<Navigate to="/login" />)} />
            <Route path="/tickets/update" element={user ? (<Layout><UpdateTicket /></Layout>) : (<Navigate to="/login" />)} />
            <Route path="/ticket-summary" element={<TicketSummary />} />
            <Route path="/ticket-search" element={<TicketSearch />} />
            <Route path="/my-tickets" element={user ? (<Layout><MyTickets /></Layout>) : (<Navigate to="/login" />)} />
            <Route path="/assigned-tickets" element={user ? (<Layout><AssignedTickets /></Layout>) : (<Navigate to="/login" />)} />

            {/* Settings Routes (Admin only) */}
            <Route path="/org-settings" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><OrganizationSettings /></Layout></RoleBasedRoute>} />
            <Route path="/admin/notification-provider-settings" element={<RoleBasedRoute allowedRoles={['ADMINISTRATOR']}><Layout><NotificationProviderSettings /></Layout></RoleBasedRoute>} />
            <Route path="/settings" element={<RoleBasedRoute allowedRoles={['ADMINISTRATOR', 'ADMIN']}><Layout><Settings /></Layout></RoleBasedRoute>} />
            <Route path="/settings/new-org" element={<RoleBasedRoute allowedRoles={['ADMINISTRATOR']}><Layout><NewOrg /></Layout></RoleBasedRoute>} />
            <Route path="/settings/new-dept" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><NewDept /></Layout></RoleBasedRoute>} />
            <Route path="/settings/new-team" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><NewTeam /></Layout></RoleBasedRoute>} />
            <Route path="/settings/ticket-heads" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><TicketHeads /></Layout></RoleBasedRoute>} />
            <Route path="/settings/new-phead" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><NewPhead /></Layout></RoleBasedRoute>} />
            <Route path="/settings/modify-head/:id" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><ModifyHead /></Layout></RoleBasedRoute>} />
            <Route path="/settings/head-check-list" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><HeadCheckList /></Layout></RoleBasedRoute>} />
            <Route path="/settings/new-category" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><NewCategory /></Layout></RoleBasedRoute>} />
            <Route path="/settings/new-ticket-priority" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><NewPriority /></Layout></RoleBasedRoute>} />
            <Route path="/settings/new-ticket-status" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><NewProgressStatus /></Layout></RoleBasedRoute>} />
            <Route path="/settings/modify-category" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><ModifyCategory /></Layout></RoleBasedRoute>} />

            {/* Cliente Routes */}
            <Route path="/cliente" element={user ? (<Layout><Cliente /></Layout>) : (<Navigate to="/login" />)} />
            <Route path="/cliente-dashboard" element={user ? (<Layout><ClientDashboard /></Layout>) : (<Navigate to="/login" />)} />

            {/* Ajustes Routes */}
            <Route path="/ajustes" element={<RoleBasedRoute allowedRoles={['ADMINISTRATOR', 'ADMIN']}><Layout><Ajustes /></Layout></RoleBasedRoute>} />
            <Route path="/ajustes/new-dyform" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><DynamicFormBuilder /></Layout></RoleBasedRoute>} />

            {/* Admin Routes */}
            <Route path="/admin/admin-list" element={<RoleBasedRoute allowedRoles={['ADMINISTRATOR']}><Layout><AdminUsers /></Layout></RoleBasedRoute>} />
            <Route path="/admin/add-admin" element={<RoleBasedRoute allowedRoles={['ADMINISTRATOR']}><Layout><AdminUser /></Layout></RoleBasedRoute>} />
            <Route path="/admin/manage-user" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><ManageUser /></Layout></RoleBasedRoute>} />
            <Route path="/admin/add-user" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><NewUser /></Layout></RoleBasedRoute>} />
            <Route path="/admin/run-query" element={<RoleBasedRoute allowedRoles={['ADMINISTRATOR']}><Layout><RunQuery /></Layout></RoleBasedRoute>} />
            <Route path="/admin/customer-api-endpoint" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><CustomerEndPoint /></Layout></RoleBasedRoute>} />
            <Route path="/admin/ticket-api-endpoint" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><ApiEndPoint /></Layout></RoleBasedRoute>} />
            <Route path="/admin/customer-form" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><CustomerForm /></Layout></RoleBasedRoute>} />
            <Route path="/admin/sms-event-settings" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><SmsEventSettings /></Layout></RoleBasedRoute>} />
            <Route path="/admin/add-sms-event/:id?" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><AddSmsEvent /></Layout></RoleBasedRoute>} />
            <Route path="/admin/report-settings" element={<RoleBasedRoute allowedRoles={['ADMIN']}><Layout><ReportSettings /></Layout></RoleBasedRoute>} />

            {/* Report Routes */}
            <Route path="/report/entries" element={<RoleBasedRoute allowedRoles={['ADMIN', 'ADMINISTRATOR']}><Layout><Entries /></Layout></RoleBasedRoute>} />
            <Route path="/report/ticket-summary-report" element={<RoleBasedRoute allowedRoles={['USER', 'ADMIN', 'ADMINISTRATOR']}><Layout><TicketSummaryReport /></Layout></RoleBasedRoute>} />
            
            {/* Unauthorized Route */}
            <Route path="/unauthorized" element={<Layout><Unauthorized /></Layout>} />
          </Routes>
        </Router>
      </AppProvider>

    </DndProvider>
  );
}

export default App;
